import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Suspense as _Suspense, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import AdtOrder from '@/components/additional/AdtOrder.vue'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import { t } from '@/plugins/i18n'
import { addAdt, addGpAdt, batchEditShopcartAdApi } from '@/apis/shopcart'
import { isD2C } from '@/store'
import { sourceCountryRef } from '../country'

export default /*#__PURE__*/_defineComponent({
  props: ['list'],
  emits: ['update'],
  setup(__props, { emit }) {

const props = __props



const proxy: any = ref(null)

const handleAdt = (t: any) => {
  const cartAdditionList = Array.isArray(t) ? t : []
  const noAdditionalFlag = t === 1 ? t : 0

  const normalAdditionList: any = []
  const apis: any = []
  props.list.map((v: any) => {
    // console.log(v)
    // 非组合商品
    if (v.productType !== 3) {
      if (!([1, 3].includes(v.oemOrderType) && v.oemProductClassificationId === 3)) {
        normalAdditionList.push({
          cartId: v.cartId,
          cartAdditionList: cartAdditionList.map((item) => {
            const adt = { ...item }
            const washAddition = v.cartAdditionList?.find((v: { additionCode: number }) => v.additionCode === 1)
            if (adt.additionCode === 1 && washAddition) {
              adt.washedlabelAdditionId = washAddition.washedlabelAdditionId
              adt.washedlabelName = washAddition.washedlabelName
              adt.washedlabelSpecification = washAddition.washedlabelSpecification
            }
            return adt
          }),
          noAdditionalFlag
        })
        // return addAdt({
        //   cartId: v.cartId,
        //   cartAdditionList,
        //   noAdditionalFlag
        // })
      }
    } else {
      // 组合商品子商品
      apis.push(
        Promise.all(v.combinationProductItemList.map((gp: any) => {
          if (!(v.oemProductClassificationId === 3)) {
            return addGpAdt({
              cartId: gp.cartId,
              shopProductSku: gp.shopProductSku,
              cartAdditionList: cartAdditionList.map((item) => {
                const adt = { ...item }
                const washAddition = gp.additionList?.find((v: { additionCode: number }) => v.additionCode === 1)
                if (adt.additionCode === 1 && washAddition) {
                  adt.washedlabelAdditionId = washAddition.washedlabelAdditionId
                  adt.washedlabelName = washAddition.washedlabelName
                  adt.washedlabelSpecification = ''
                }
                return adt
              }),
              noAdditionalFlag,
              batch: true
            })
          }
        }))
      )
    }
  })
  if (normalAdditionList.length > 0) {
    apis.push(batchEditShopcartAdApi({
      updateCartAdditionReqDTOS: normalAdditionList
    }))
  }
  Promise.all(
    apis
  ).then(() => {
    emit('update')
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex-ter change-adt", { d2c: _unref(isD2C)() }])
  }, [
    _createVNode(_component_el_button, {
      type: "primary",
      size: "small",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (proxy.value = []))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('批量编辑商品附加项')), 1)
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (proxy.value)
          ? (_openBlock(), _createBlock(AdditionDrawer, {
              key: 0,
              list: proxy.value,
              "onUpdate:list": _cache[1] || (_cache[1] = ($event: any) => ((proxy).value = $event)),
              onCommit: handleAdt,
              type: "AdtOrder",
              title: _unref(t)('批量编辑商品附加项'),
              countryCode: _unref(sourceCountryRef),
              needChangeSize: true
            }, null, 8, ["list", "title", "countryCode"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }))
  ], 2))
}
}

})